/**
 * Where the REST API lives. Set once at app boot (`apps/app/src/main.tsx`) —
 * this package stays bundler-agnostic on purpose, so it never reads
 * `import.meta.env` (Vite) or `process.env` (Next) itself.
 *
 * Web dev: empty string — Vite proxies `/api/*` to the API on :3000, so the
 * requests are same-origin and cookies work.
 * Capacitor: an absolute URL is REQUIRED — the WebView origin is
 * `capacitor://localhost`, which has no notion of "same origin" as the API.
 */
let apiBaseUrl = ''

export function setApiBaseUrl(url: string): void {
  // Trailing slash would produce `//api/...` once joined with a path.
  apiBaseUrl = url.replace(/\/$/, '')
}

export function getApiBaseUrl(): string {
  return apiBaseUrl
}

/** Absolute URL for a REST path (`/api/users/me` → `https://api.bitez.cz/api/users/me`). */
export function apiUrl(path: string): string {
  return `${apiBaseUrl}${path}`
}
